module.exports = __webpack_public_path__ + "img/CUFFMBP.71136370.jpg";